// extracted by mini-css-extract-plugin
export default {"alarmManagementForm":"AlarmManagementForm_alarmManagementForm__0SRcu","buttons":"AlarmManagementForm_buttons__ikwua","label":"AlarmManagementForm_label__Yb81e"};